import templateUrl from './resourceDelete.html'

/**
 * Resource Delete route component
 *
 * @type {ngComponent}
 * @todo Document
 */
export const tmrResourceDelete = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrResourceDeleteController',
  bindings: {
    resource: '<',
    question: '<',
    toast: '<',
    canDelete: '<',
    redirect: '<',
  },
}

/**
 * Controller of component {@link tmrResourceDelete}.
 *
 * @type {ngController}
 */
export class tmrResourceDeleteController {
  static ngType = 'controller'

  constructor($state, $stateParams, TmrToast) {
    'ngInject'
    Object.assign(this, { $state, $stateParams, TmrToast })
  }

  $onInit() {
    // If redirect binding is not present, set to this tree's list state.
    this.redirect = this.$stateParams.redirect
      ? this.$stateParams.redirect
      : '^.^.list'
  }

  onDelete() {
    return this.resource
      .$remove()
      .then(() =>
        this.$state.go(this.redirect, null, { reload: true, inherit: false })
      )
      .then(() => this.TmrToast.success(this.toast))
      .catch(err => this.TmrToast.exception(err))
  }
}
